// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"93b4bd7f","803":"f9d47aa9","1815":"b12ddff7","3024":"93b4bd7f","3082":"93b4bd7f"}[chunkId] + ".chunk.css";
};